import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, map } from 'rxjs';

import { CollageCloudService, EntryPoint, EntryPointService } from '@mirage-projects/cw-commons';
import { UtilsPcvizService } from '@mirage-projects/cw-pcviz-core';

/**
 *  This service manages Collage Cloud entry points.
 */
@Injectable({ providedIn: 'root' })
export class AppCollageCloudService implements CollageCloudService {
    constructor(
        private http: HttpClient,
        private utilsPcvizService: UtilsPcvizService,
        private entryPointService: EntryPointService
    ) {}

    /**
     * Gets the thumbnail url redirection
     */
    getRedirectURL(url: string): Observable<string> {
        const timeStampCache = this.utilsPcvizService.getTimeStampCache();

        const queryChar = url.indexOf('?') !== -1 ? '&' : '?';
        const timeStampString = `${queryChar}tsccw=${timeStampCache.getTimeStamp(url)}`;

        return this.http.get<string>(url + timeStampString).pipe(map((response: any) => response.location));
    }

    /**
     * Tries to login into the
     * @param username user name
     * @param password user name's password
     */
    login(username: string, password: string): Observable<any> {
        const entryPoint = this.entryPointService.getResource(EntryPoint.CLOUD_ID) as string;
        return this.http.post(entryPoint, { username, password });
    }
}
